export function isUrl(string) {
    // Regular expression pattern to match URL format
    var urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/.*)?$/i;

    // Test the string against the pattern
    return urlPattern.test(string);
}
